// UGC dari file jadi (2026-10-11): video kompilasi yang sudah siap diunggah langsung dari device,
// tanpa lagu/editor/render. Dikirim per potongan 50 MB (tiap potongan dicoba ulang s.d. 3x), lalu
// server memeriksa file (ffprobe) dan proyek langsung siap: lanjut SEO, pilih channel, jadwal, Setujui.
import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('sm_token')}` });
const mb = n => (n / 1048576).toFixed(n > 1073741824 ? 0 : 1);

export default function UgcUploadJadi({ onDone }) {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [thumb, setThumb] = useState(null);
  const [kids, setKids] = useState(false);
  const [ai, setAi] = useState(false);
  const [prog, setProg] = useState(null); // {sent, total, step}
  const [err, setErr] = useState('');

  async function kirim() {
    setErr('');
    if (!title.trim()) return setErr('Judul video wajib diisi');
    if (!file) return setErr('Pilih file video dulu');
    try {
      setProg({ sent: 0, total: file.size, step: 'Menyiapkan…' });
      const init = await axios.post(`${API}/api/ugc/projects/file-init`,
        { title: title.trim(), size: file.size, filename: file.name, made_for_kids: kids, contains_synthetic_media: ai }, { headers: auth() });
      const { id, chunk_size: cs, chunks } = init.data;
      for (let i = 0; i < chunks; i++) {
        const part = file.slice(i * cs, Math.min(file.size, (i + 1) * cs));
        let ok = false, lastErr = null;
        for (let t = 0; t < 3 && !ok; t++) {
          try {
            await axios.post(`${API}/api/ugc/projects/${id}/file-chunk?index=${i}`, part, {
              headers: { ...auth(), 'Content-Type': 'application/octet-stream' },
              onUploadProgress: e => setProg({ sent: i * cs + (e.loaded || 0), total: file.size, step: `Mengunggah potongan ${i + 1}/${chunks}` }),
            });
            ok = true;
          } catch (e) { lastErr = e; await new Promise(r => setTimeout(r, 2000 * (t + 1))); }
        }
        if (!ok) throw lastErr;
      }
      setProg({ sent: file.size, total: file.size, step: 'Memeriksa video di server…' });
      await axios.post(`${API}/api/ugc/projects/${id}/file-finish`, {}, { headers: auth() });
      if (thumb) {
        const fd = new FormData(); fd.append('image', thumb);
        await axios.post(`${API}/api/ugc/projects/${id}/thumbnail-upload`, fd, { headers: auth() }).catch(() => {});
      }
      setProg(null); setTitle(''); setFile(null); setThumb(null);
      onDone && onDone(id);
    } catch (e) {
      setProg(null);
      setErr(e.response?.data?.error || 'Upload gagal — cek koneksi lalu coba lagi');
    }
  }

  const pct = prog ? Math.floor(prog.sent / Math.max(1, prog.total) * 100) : 0;
  return (
    <div style={{ background: '#F3F4F6', padding: 18, borderRadius: 14, marginBottom: 24 }}>
      <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>📁 Upload Video Jadi</div>
      <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 12 }}>
        Sudah punya video kompilasi siap upload? Unggah langsung — tanpa pilih lagu, tanpa editor, tanpa render. Setelah itu tinggal isi SEO, pilih channel, dan jadwal.
      </div>
      <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Judul video YouTube" disabled={!!prog}
        style={{ width: '100%', maxWidth: 420, padding: '9px 12px', borderRadius: 8, boxSizing: 'border-box', marginBottom: 10 }} />
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
        <label className="btn btn-outline" style={{ fontSize: 12, cursor: prog ? 'default' : 'pointer' }}>
          🎬 {file ? 'Ganti video' : 'Pilih file video'}
          <input type="file" accept="video/mp4,video/quicktime,video/x-matroska,video/webm,.mp4,.mov,.mkv,.webm" style={{ display: 'none' }} disabled={!!prog}
            onChange={e => { setFile(e.target.files[0] || null); e.target.value = ''; }} />
        </label>
        <label className="btn btn-outline" style={{ fontSize: 12, cursor: prog ? 'default' : 'pointer' }}>
          🖼️ {thumb ? 'Ganti thumbnail' : 'Thumbnail (opsional)'}
          <input type="file" accept="image/jpeg,image/png,image/webp" style={{ display: 'none' }} disabled={!!prog}
            onChange={e => { setThumb(e.target.files[0] || null); e.target.value = ''; }} />
        </label>
      </div>
      {(file || thumb) && (
        <div style={{ fontSize: 12, color: '#374151', marginBottom: 10, overflowWrap: 'anywhere' }}>
          {file && <div>Video: {file.name} · {mb(file.size)} MB</div>}
          {thumb && <div>Thumbnail: {thumb.name}</div>}
        </div>
      )}
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, marginBottom: 6, cursor: 'pointer' }}>
        <input type="checkbox" checked={kids} onChange={e => setKids(e.target.checked)} style={{ width: 15, height: 15, margin: 0 }} disabled={!!prog} />
        Video ini dibuat untuk anak-anak
      </label>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, marginBottom: 12, cursor: 'pointer' }}>
        <input type="checkbox" checked={ai} onChange={e => setAi(e.target.checked)} style={{ width: 15, height: 15, margin: 0 }} disabled={!!prog} />
        Mengandung konten yang dibuat/diubah dengan AI
      </label>
      {prog && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6B7280', marginBottom: 4 }}>
            <span>{prog.step}</span><span>{pct}% · {mb(prog.sent)}/{mb(prog.total)} MB</span>
          </div>
          <div style={{ height: 8, background: '#E5E7EB', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: pct + '%', background: 'linear-gradient(90deg,#FF5722,#FFB347)', transition: 'width .3s' }} />
          </div>
          <div style={{ fontSize: 11, color: '#6B7280', marginTop: 4 }}>Jangan tutup halaman ini sampai selesai.</div>
        </div>
      )}
      {err && <div style={{ fontSize: 12.5, color: '#DC2626', marginBottom: 10 }}>{err}</div>}
      <button className="btn btn-gold" disabled={!!prog} onClick={kirim}>{prog ? 'Mengunggah…' : '⬆ Upload Video'}</button>
      <div style={{ fontSize: 11, color: '#6B7280', marginTop: 8 }}>MP4, MOV, MKV, atau WEBM · maks 10 GB · harus berisi gambar & suara.</div>
    </div>
  );
}
